import { cx } from '@/lib/cx';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';
export type ButtonSize = 'sm' | 'md';

const VARIANTS: Record<ButtonVariant, string> = {
  primary: 'bg-accent text-paper hover:bg-accent-strong border-transparent',
  secondary: 'bg-surface-2 text-ink border-line hover:border-ink-soft/50',
  ghost: 'bg-transparent text-ink-soft border-transparent hover:bg-surface-2 hover:text-ink',
  danger: 'bg-critical-soft text-critical border-critical/40 hover:border-critical',
};

const SIZES: Record<ButtonSize, string> = {
  sm: 'h-8 px-3 text-sm gap-1.5',
  md: 'h-10 px-4 text-base gap-2',
};

/** Shared with links that look like buttons. */
export function buttonClasses(variant: ButtonVariant = 'primary', size: ButtonSize = 'md') {
  return cx(
    'inline-flex items-center justify-center rounded-md border font-medium transition-colors',
    'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent',
    'disabled:cursor-not-allowed disabled:opacity-50',
    VARIANTS[variant],
    SIZES[size],
  );
}
